import { Pause } from '@phosphor-icons/react';

export default Pause;
